import {post, get} from '../utils/request';
import {encrypt} from "@/utils/rsaEncrypt";

export const login = (data) => {
    data.password = encrypt(data.password)
    return post('/authentication/pass', data)
}

export const loginDD = (query) => {
    return get('/common/login' , query)
}

export const getLoginUserInfo = () => get('/getLoginUserInfo' , null)

export const resetPass = (data) => post('/system/admin/pass/reset/cp', data)